module.exports = __webpack_public_path__ + "img/logo.2d34db3d.png";